import { useState } from 'react'
import { Button, Dialog, Field, Radio, Select } from '@/components/common'
import { CATALOG_SOURCES, REGULATIONS } from './catalogSources'
import { PREVIEW_INVENTORY } from './previewInventory'
import styles from './nativeWorkspace.module.css'

// Rehearsal changes what the preview reads and simulates, never what is saved.
// Its data, regulation and inventory feed the live catalog queries and the
// scenario sent to paired phones, so they apply together.
export function RehearsalDialog({ workspace, onClose }) {
  const [source, setSource] = useState(workspace.catalogSource)
  const [regulation, setRegulation] = useState(workspace.jurisdiction)
  const [inventory, setInventory] = useState(workspace.previewInventory || 'current')
  const apply = () => {
    workspace.setCatalogSource(source)
    workspace.setJurisdiction(regulation)
    workspace.setPreviewInventory(inventory)
    onClose()
  }
  return <Dialog open title="Rehearse" onClose={onClose} footer={<><Button variant="secondary" onClick={onClose}>Cancel</Button><Button onClick={apply}>Apply</Button></>}>
    <div className={styles.rehearsal}>
      <fieldset className={styles.rehearsalSources}>
        <legend>Data</legend>
        {CATALOG_SOURCES.map((item) => {
          const available = item.value === 'sample' || workspace.liveSources.includes(item.value)
          return <Radio key={item.value} name="rehearsal-data" value={item.value} label={item.label} description={available ? item.description : 'Not connected'} disabled={!available} checked={source === item.value} onChange={() => setSource(item.value)} />
        })}
      </fieldset>
      <Field label="Regulation"><Select value={regulation} onChange={(event) => setRegulation(event.target.value)}>{REGULATIONS.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}</Select></Field>
      <Field label="Inventory"><Select value={inventory} onChange={(event) => setInventory(event.target.value)}>{PREVIEW_INVENTORY.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}</Select></Field>
    </div>
  </Dialog>
}
